export default "__VITE_ASSET__DBr30asD__"